import { memo, useCallback, useEffect, useState } from "react";
import { Grid, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Typography } from '@mui/material';
import { getPaymentHistory } from "services/payments";
import { formatCurrency } from "utils";

const PaymentHistory = ({paymentId, pageRef}) => {

  const [payments, setPayments] = useState(null);

  const fetchPaymentHistory = useCallback(() => {
    const controller = new AbortController();

    getPaymentHistory(paymentId, {signal: controller.signal, pageRef}).then(({response, error}) => {
      if(error?.message === 'canceled') return;
      // Return if any error
      if(error)return setPayments([])
      setPayments(response);
    });
    return controller;
  }, [pageRef, paymentId]);

  useEffect(() => {
    const controller = fetchPaymentHistory();
    return () => {
      controller.abort();
    }
  }, [fetchPaymentHistory])
  
  return payments ? (
    <Grid container>
      <Grid item xs={12}>
        {payments?.length > 0 ? (
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Amount Paid</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payments?.map(({paymentDate, amountPaid}, i) => 
                  <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                    <TableCell>{paymentDate}</TableCell>
                    <TableCell>{formatCurrency(amountPaid)}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ): (
          <Typography variant="subtitle1" color="error.light" textAlign="center" my={4}>No data available</Typography>
        )}
      </Grid>
    </Grid>
  ): null;
}
 
export default memo(PaymentHistory);